import logger from '@/logger'

const LogWebsocketSubscriber = {
  init: (socket) => {
    const socketLog = logger.extend('socket')
    socket.onAny((eventName, ...args) => {
      socketLog(`Event ${eventName}`, args)
    })
  },
}

export default LogWebsocketSubscriber
